// The eyebrow primitive. Per design spec §0.2: ALWAYS uppercase, ALWAYS
// text-fg-mute, ALWAYS tracking-[0.18em], ALWAYS font-medium.

import type { ReactNode } from 'react';

interface EyebrowProps {
  children: ReactNode;
  className?: string;
}

export function Eyebrow({ children, className = '' }: EyebrowProps) {
  return (
    <span className={`text-eyebrow text-fg-mute uppercase font-medium ${className}`}>
      {children}
    </span>
  );
}
